/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_7Inputs */

const en_us2_onboarding_parq_7 = /** @type {(inputs: Onboarding_Parq_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you know of any other reason why you should not do physical activity?`)
};

const pt_br2_onboarding_parq_7 = /** @type {(inputs: Onboarding_Parq_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você sabe de algum outro motivo pelo qual não deveria fazer atividade física?`)
};

const es_419_onboarding_parq_7 = /** @type {(inputs: Onboarding_Parq_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Conoces alguna otra razón por la que no deberías hacer actividad física?`)
};

const pt_pt2_onboarding_parq_7 = /** @type {(inputs: Onboarding_Parq_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conheces algum outro motivo pelo qual não devas fazer atividade física?`)
};

const fr_fr2_onboarding_parq_7 = /** @type {(inputs: Onboarding_Parq_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connais-tu une autre raison pour laquelle tu ne devrais pas faire d'activité physique ?`)
};

const de_de2_onboarding_parq_7 = /** @type {(inputs: Onboarding_Parq_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kennst du einen anderen Grund, warum du dich nicht körperlich betätigen solltest?`)
};

const it_it2_onboarding_parq_7 = /** @type {(inputs: Onboarding_Parq_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conosci qualche altro motivo per cui non dovresti fare attività fisica?`)
};

/**
* | output |
* | --- |
* | "Do you know of any other reason why you should not do physical activity?" |
*
* @param {Onboarding_Parq_7Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_7 = /** @type {((inputs?: Onboarding_Parq_7Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_7Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_7(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_7(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_7(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_7(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_7(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_7(inputs)
	return en_us2_onboarding_parq_7(inputs)
});
export { onboarding_parq_7 as "onboarding.parq.7" }